import {Link} from 'react-router-dom';
import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors} from "patient-ping-remedy/packages/theme";
import {LabelTypography} from "patient-ping-remedy/packages/typography";

interface StyledDemographicProps {
  color?: string;
  fontSize?: string;
  fontWeight?: number;
  lineHeight?: string;
  whiteSpace?: string;
  onClick?(): void;
}

export const StyledDemographicComponent = styled(LabelTypography)<StyledDemographicProps>`
  font-size: ${(props) => props.fontSize || "1.4rem"};
  font-weight: ${(props) => props.fontSize || 400};
  color: ${(props) => props.color || colors.charcoal};
  line-height: ${(props) => props.lineHeight || "1.8rem"};
  white-space: ${(props) => props.whiteSpace || "normal"};

  ${(props) => props.onClick && css`
    &:hover {
      color: ${colors.purple4};
      cursor: pointer;
    }
  `}
`;

export const StyledDemographicLink = styled(Link)`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: ${colors.purple4};
  }
`;

